/**
 * Help Center enhancements.
 *
 * The FAQ content is page-authored HTML written in Shopify admin, so there is
 * no Liquid to add markup to. This builds the search box and jump nav from the
 * content that is already there: every <h2> becomes a section, every <details>
 * an entry.
 *
 * The <details> elements themselves are left alone — native disclosure is
 * keyboard accessible and works without JS. If this script never runs, the FAQ
 * still works exactly as it did; it only loses the search and the jump links.
 */
(() => {
  const root = document.querySelector('.cosrea-faq');
  if (!root) return;

  const headings = [...root.querySelectorAll('h2')];
  const items = [...root.querySelectorAll('details')];
  if (!items.length) return;

  const slug = (s) =>
    s.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').slice(0, 40);

  // Which heading does each <details> belong to? Walk the DOM in order.
  const sectionOf = new Map();
  let current = null;
  [...root.children].forEach((el) => {
    if (el.tagName === 'H2') current = el;
    else if (current) {
      (el.matches('details') ? [el] : [...el.querySelectorAll('details')])
        .forEach((d) => sectionOf.set(d, current));
    }
  });

  headings.forEach((h) => { if (!h.id) h.id = 'faq-' + slug(h.textContent); });

  // ---- build the tools ----
  const tools = document.createElement('div');
  tools.className = 'faq-tools';
  tools.innerHTML = `
    <div class="faq-search-row">
      <input class="faq-search" type="search" autocomplete="off"
             placeholder="Search ${items.length} questions…"
             aria-label="Search frequently asked questions">
      <button class="faq-search-clear" type="button" aria-label="Clear search" hidden>✕</button>
    </div>
    ${headings.length > 1 ? `<nav class="faq-jump" aria-label="Jump to section">
      ${headings.map((h) => `<a href="#${h.id}">${h.textContent.trim()}</a>`).join('')}
    </nav>` : ''}
    <p class="faq-count" role="status" aria-live="polite" hidden></p>`;
  root.prepend(tools);

  const input = tools.querySelector('.faq-search');
  const clear = tools.querySelector('.faq-search-clear');
  const count = tools.querySelector('.faq-count');
  const jump = tools.querySelector('.faq-jump');

  const apply = (q) => {
    const term = q.trim().toLowerCase();
    clear.hidden = !term;

    if (!term) {
      items.forEach((d) => { d.hidden = false; d.open = false; });
      headings.forEach((h) => { h.hidden = false; });
      count.hidden = true;
      if (jump) jump.hidden = false;
      return;
    }

    let hits = 0;
    items.forEach((d) => {
      const match = d.textContent.toLowerCase().includes(term);
      d.hidden = !match;
      // Open matches so the answer is visible without a second click.
      d.open = match;
      if (match) hits++;
    });

    // Hide a section heading when nothing under it survived the filter.
    headings.forEach((h) => {
      const any = items.some((d) => sectionOf.get(d) === h && !d.hidden);
      h.hidden = !any;
    });

    if (jump) jump.hidden = true;
    count.hidden = false;
    count.textContent = hits
      ? `${hits} of ${items.length} questions match “${q.trim()}”`
      : `No questions match “${q.trim()}” — try a shorter word, or browse the sections below.`;
  };

  let t;
  input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => apply(input.value), 120); });
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { input.value = ''; apply(''); } });
  clear.addEventListener('click', () => { input.value = ''; apply(''); input.focus(); });
})();
